import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { ConfigurationDefaults, LEFT_RIGHT } from 'franke-trough-dependencies';

import { GlobalPrivateState, } from 'src/api';
import MSG from './ElementPositions.messages';
import { FormattedMessage } from 'react-intl';

export interface ElementPositionProps {
  defaults: ConfigurationDefaults<LEFT_RIGHT[] | null, LEFT_RIGHT[] | null>;
  selected: (null | LEFT_RIGHT)[];
  disabled: boolean;
  onChange?(selected: ElementPositionState['selected']): void;
}

export interface ElementPositionState {
  selected: {left: boolean, right: boolean};
}

export class ElementPositionPartial extends React.Component<ElementPositionProps, any> {
  constructor(props: ElementPositionProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = {
      selected: {
        left: props.selected.indexOf('left') > -1,
        right: props.selected.indexOf('right') > -1,
      },
    }; 
  }

  public render() {
    const {
      selected
    } = this.state;

    return (
      <div className="partial-corner-design-position">
        <div className="row">
          <div className="col-11 offset-1">
            <div className="row">
              {this.props.defaults.values && this.props.defaults.values.map((value, index) => {
                const key = `corner_design_position_item_${index}`;
                return (
                  <div key={key} className="col-12">
                    <label className={classNames({
                      'disabled': this.props.disabled
                    })}>
                      <FormattedMessage {...MSG[value]}/>
                      <input
                        type="checkbox"
                        name={value}
                        value={value}
                        checked={selected[value]}
                        onChange={this.handleChange}
                        disabled={this.props.disabled}
                      />
                      <span className="checkmark" />
                    </label>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>) {
    const target = event.target as HTMLInputElement;
    const selected = this.state.selected;
    const name = target.name as LEFT_RIGHT;
    
    selected[name] = !this.state.selected[name];

    this.setState({selected: selected});
    
    if (this.props.onChange) {
      this.props.onChange(selected);
    }
  }
}

export const ElementPosition = connect((state: GlobalPrivateState) => ({
  // configuration: state.configuration,
}))(ElementPositionPartial);

export default ElementPosition;